import React from "react"
import { DiGithubBadge } from "react-icons/di"
import { FaTwitter, FaLinkedin } from "react-icons/fa"

export default [
  {
    icon: <FaLinkedin />,
    url: "https://www.linkedin.com/in/morgan-baker-developer-inverness",
  },
  {
    icon: <FaTwitter />,
    url: "https://www.twitter.com",
  },
  {
    icon: <DiGithubBadge />,
    url: "https://github.com/bagseye",
  },
]
